import { getData, postData } from '@/utils/http'
import config from "@/config"

export default {
	namespaced: true,
	state: {
		tableLoading: true,
		addLoading: false,
		activeItem: null,
		tableList: [],
		//查询条件
		name: '',
		projectId: '',
		code: '',
		status: '',
		deptId: "",
		goodsType: "",
		pageIndex: 1,
		total: 0,
	},
	mutations: {
		CHANGE_TABLE_LOADING(state, tableLoading) {
			state.tableLoading = tableLoading
		},
		CHANGE_ADD_LOADING(state, addLoading) {
			state.addLoading = addLoading
		},
		CHANGE_TABLE_DATA(state, changeData) {
			state.tableList = changeData.data.rows;
			state.total = changeData.total
		},
		CHANGE_ACTIVE_ITEM(state, item) {
			state.activeItem = item
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
				state[changeData['changeKey']] = [changeData['data']]
			} else {
				state[changeData['changeKey']] = changeData['data']
			}
		},
		CHANGE_TABLE_INDEX(state, value) {
			state.pageIndex = value
		}
	},
	actions: {
		//获取项目列表
		getList({ commit, state }) {
			return new Promise(resolve => {
				getData(`logistics/route/list?projectId=${state.projectId}&status=${state.status}&name=${state.name}&code=${state.code}&page=${state.pageIndex}&size=${config.pageSize}&goodsType=${state.goodsType}`).then(
					res => {
						if (res.state == 1) {
							commit('CHANGE_TABLE_DATA', res)
							resolve({
								state: 1,
								msg: '操作成功'
							})
						} else {
							resolve({
								state: 0,
								msg: res.msg
							})
						}
					}
				)
			})
		},

		//获取我的项目列表
		getMyProjectList({ commit, state }, deptId) {
			return new Promise(resolve => {
				getData(`logistics/project/my/list?deptId=${deptId}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						})
					}
				})
			})
		},

		//保存
		add({ commit }, addData) {
			return new Promise(resolve => {
				postData(`logistics/route/marketer/save`, addData).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},

		getById({ commit, state }) {
			return new Promise(resolve => {
				getData(`logistics/route/get/${state.activeItem.id}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},

		audit({ commit }, id) {
			return new Promise(resolve => {
				postData(`logistics/route/marketer/submit/${id}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},

		//禁用/启用
		disable({ commit }, id) {
			return new Promise(resolve => {
				postData(`logistics/route/update/status/${id}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},

		//退回
		cancelRoute({ commit }, data) {
			return new Promise(resolve => {
				postData(`/logistics/route/marketer/back`, data).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},

		//获取全部状态的的路线，根据路线编码后四位动态生成路线编码
		getAllRouteLiveCode({ commit, state }, projectId) {
			return new Promise(resolve => {
				getData(`logistics/route/list?projectId=${projectId}&status=&name=&code=&page=1&size=999999`).then(res => {
					if (res.state == 1) {
						if (res.data.rows.length == 0) {
							resolve({
								state: 1,
								data: '0001',
								msg: '操作成功'
							})
						} else {
							var codeStringArray = []
							var codeNumberArray = []
							for (var i = 0; i < res.data.rows.length; i++) {
								codeStringArray = res.data.rows[i].code.split('-')
								codeNumberArray.push(parseInt(codeStringArray[codeStringArray.length - 1]))
							}
							resolve({
								state: 1,
								data: (Math.max(...codeNumberArray) + 1).toString().padStart(4, '0'),
								msg: '操作成功'
							})
						}
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},


		//删除新建的路线
		removeNewRoute({ commit, state }, id) {
			return new Promise((resolve) => {
				postData(`logistics/route/marketer/delete/${id}`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},



		getAllowOrg({ commit, state }, year) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dept/get/list`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},


		//获取系统内置路线
		//获取列表
		getScoutedList({ commit, state },name) {
			return new Promise((resolve) => {
				getData(`logistics/route/scouted/page?page=1&size=20&name=${state.name}`).then((res) => {
					if (res.state == 1) {
						console.log(res);
						resolve({
							state: 1,
							data:res.data.rows,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							data:[],
							msg: res.msg
						});
					}
				})
			})
		},

		//获取详情
		getScoutedById({ commit, state },id) {
			return new Promise((resolve) => {
				getData(`logistics/route/scouted/get/${id}`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						});
					}
				})
			})
		},





		//写入当前操作条目
		setActiveItem({ commit }, item) {
			commit('CHANGE_ACTIVE_ITEM', item)
		},

		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit('CHANGE_SEARCH_COLL', changeData)
		},
		//修改分页
		setPageIndex({ commit }, value) {
			commit('CHANGE_TABLE_INDEX', value)
		},
		//修改添加loading
		changeAddLoading({ commit }, value) {
			commit('CHANGE_ADD_LOADING', value)
		},
		//修改添加loading
		changeListLoading({ commit }, value) {
			commit('CHANGE_TABLE_LOADING', value)
		}
	}
}
